import {useEffect, useRef, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator, AlertModal,
    CCText,
    TouchableWithoutFeedback,
    View
} from '../../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import {
    BorderlessButton,
    ThemeButton
} from '../../../../custom-packages/react-button-package/ButtonPackage';

import TMenuEditorScreen from './Translations/TMenuEditorScreen';

import AppConfig from '../../../../AppConfig';

import {useParams} from "react-router-dom";
import Styles from "../../../../Styles";
import {GetAuthObject} from "../../../../authentication/AuthFunctions";
import MenuEditorTopBar from "./Components/MenuEditorTopBar";
import Menu from "../../../../models/menu/Menu";
import MenuSection from "../../../../models/menu/MenuSection";
import ChocoForm from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoControl from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";
import {FormModalTS} from '../../../../custom-packages/react-chocoforms/typescript/ChocoFormTS';
import MenuEditorBottomBar from "./Components/MenuEditorBottomBar";
import DropdownMenu from "../../../../custom-packages/dropdown-menu/DropdownMenu";
import GearIcon from "../../../../assets/custom-icons/GearIcon";
import {RegisterEvent} from "../../../../AnalyticsFunctions";

const MenuEditorScreen = (props) => {
    const auth = GetAuthObject();
    const pdfInputRef = useRef(null)

    const params = useParams()
    const id = params.id;

    const [uploadingFile, setUploadingFile] = useState(false);
    const [pdfUploadMessage, setPdfUploadMessage] = useState(null);
    const [isDigital, setIsDigital] = useState(true);
    const [isPdf, setIsPdf] = useState(false);
    const [isUpdatingType, setIsUpdatingType] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isNewSectionModalOpen, setIsNewSectionModalOpen] = useState(false);
    const [menu, setMenu] = useState<Menu>(new Menu());
    const [sections, setSections] = useState<Array<MenuSection>>([]);

    const [sectionForm, setSectionForm] = useState<ChocoForm>(new ChocoForm({
        MSE_NAME: new ChocoControl({
            elementType: 'input',
            elementConfig: {
                placeholder: TMenuEditorScreen[AppConfig.lang].SECTION_NAME,
                autoCapitalize: 'words'
            },
            label: TMenuEditorScreen[AppConfig.lang].SECTION_NAME + '*',
            value: '',
            errorMessage: '',
            validation: new ChocoValidation({
                required: true,
                maxLength: 50
            }),
        }),
        MSE_DESCRIPTION: new ChocoControl({
            elementType: 'input',
            elementConfig: {
                placeholder: TMenuEditorScreen[AppConfig.lang].SECTION_DESC,
                autoCapitalize: 'words'
            },
            label: TMenuEditorScreen[AppConfig.lang].SECTION_DESC,
            value: '',
            errorMessage: '',
            validation: new ChocoValidation({
                required: false,
                maxLength: 500
            }),
        }),
    }));

    const updateType = async (type) => {
        setIsUpdatingType(true)

        const response = await fetch(AppConfig.URL + '/Menu/UpdateType/' + id + '?type=' + type, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
        });

        const data = await response.json();

        if (data.success) {

            switch (type) {
                case 'DIG':
                    setIsDigital(true)
                    setIsPdf(false)
                    break;
                case 'PDF':
                    setIsDigital(false)
                    setIsPdf(true)

                    if (pdfInputRef && pdfInputRef.current) { // @ts-ignore
                        pdfInputRef.current.click()
                    }

                    break;
            }

            const updatedMenu = {...menu};

            updatedMenu.men_type = type;

            // @ts-ignore
            setMenu(updatedMenu)
        }

        setIsUpdatingType(false)
    }

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + "/Menu/FetchCategories/" + id, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                }
            });

            const json = await response.json();

            setSections(json.sections);

            setLoading(false);
        };

        f();
    }, [id]);

    if (loading)
        return <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start'}}>
            <MenuEditorTopBar
                menuID={id}
            />
            <MenuEditorBottomBar
                menuID={id}
            />
            <View style={{height: 70}}></View>
            <ActivityIndicator style={{marginTop: 170}}/>
        </View>

    return <View>
        <MenuEditorTopBar
            menuID={id}
        />
        <MenuEditorBottomBar
            menuID={id}
        />
        <View style={{height: 70}}></View>
        <View className={'row'}>
            {
                false ?

                    <View className={'col-lg-4'}>
                        <View
                            className={'card'}
                            style={{marginBottom: 15}}
                        >
                            <View
                                className={'card-body'}
                                style={{padding: 0}}
                            >
                                <View
                                    style={{
                                        padding: 15,
                                        borderBottom: '1px solid #dddddd'
                                    }}
                                >
                                    <h1
                                        style={{marginBottom: 0}}
                                    >
                                        {TMenuEditorScreen[AppConfig.lang].MENU_TYPE}
                                    </h1>
                                    <CCText
                                        style={{
                                            color: '#666666',
                                            fontStyle: 'italic',
                                            fontSize: '1.15rem'
                                        }}
                                    >
                                        {TMenuEditorScreen[AppConfig.lang].MENU_TYPE_DESC}
                                    </CCText>
                                </View>
                                <View
                                    style={{padding: 15, paddingTop: 0}}
                                >
                                    <TouchableWithoutFeedback
                                        disabled={isUpdatingType}
                                        onPress={() => {
                                            updateType('DIG')
                                        }}
                                    >
                                        <View style={{padding: '15px 0'}}>
                                            <View style={{flexDirection: 'row', justifyContent: 'flex-start'}}>
                                                {
                                                    isUpdatingType && !isDigital ?
                                                        <ActivityIndicator
                                                            size={15}
                                                        />
                                                        :
                                                        <input
                                                            type={'radio'}
                                                            name={'type'}
                                                            checked={isDigital}
                                                        />
                                                }
                                                <CCText
                                                    style={{marginLeft: 10, fontSize: "1.4rem", fontWeight: 'bold'}}
                                                >
                                                    {TMenuEditorScreen[AppConfig.lang].DIGITAL_TYPE}
                                                </CCText>
                                            </View>
                                            <CCText
                                                style={{textAlign: 'justify'}}
                                            >
                                                {TMenuEditorScreen[AppConfig.lang].DIGITAL_TYPE_DESC}
                                            </CCText>
                                        </View>
                                    </TouchableWithoutFeedback>
                                    <TouchableWithoutFeedback
                                        onPress={() => {
                                            updateType('PDF')
                                        }}
                                    >
                                        <View style={{padding: '15px 0'}}>
                                            <View style={{flexDirection: 'row', justifyContent: 'flex-start'}}>
                                                {
                                                    isUpdatingType && !isPdf ?
                                                        <ActivityIndicator
                                                            size={15}
                                                        />
                                                        :
                                                        <input
                                                            type={'radio'}
                                                            name={'type'}
                                                            checked={isPdf}
                                                        />
                                                }
                                                <CCText
                                                    style={{marginLeft: 10, fontSize: "1.4rem", fontWeight: 'bold'}}
                                                >
                                                    {TMenuEditorScreen[AppConfig.lang].PDF_TYPE}
                                                </CCText>
                                            </View>
                                            <CCText
                                                style={{textAlign: 'justify'}}
                                            >
                                                {TMenuEditorScreen[AppConfig.lang].PDF_TYPE_DESC}
                                            </CCText>
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                            </View>
                        </View>
                    </View>
                    :
                    null
            }
            {
                isDigital ?
                    <View className={'col-12'}>
                        <View>
                            <View
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <h1
                                    style={{marginBottom: 0}}
                                >
                                    {TMenuEditorScreen[AppConfig.lang].SECTIONS}
                                </h1>
                                <ThemeButton
                                    text={TMenuEditorScreen[AppConfig.lang].ADD_SECTION}
                                    onPress={() => {
                                        RegisterEvent({
                                            source: window.location.href,
                                            sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                                            token: auth.token,
                                            action: 'BUTTON_ADD_CATEGORY_CLICK'
                                        })

                                        setIsNewSectionModalOpen(!isNewSectionModalOpen)
                                    }}
                                    textStyle={{fontSize: 16}}
                                />
                            </View>
                            <CCText
                                style={{
                                    color: '#666666',
                                    fontStyle: 'italic',
                                    fontSize: '1.15rem'
                                }}
                            >
                                {TMenuEditorScreen[AppConfig.lang].SECTIONS_DESC}
                            </CCText>
                        </View>
                        <div
                            className={'row'}
                        >
                            {
                                !sections || sections.length == 0 ?
                                    <View
                                        className={'col-12'}
                                        style={{
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            paddingTop: 30
                                        }}
                                    >
                                        <CCText
                                            style={{
                                                fontSize: '1.5rem',
                                                color: 'gray',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {TMenuEditorScreen[AppConfig.lang].NO_CATEGORIES_ADDED}
                                        </CCText>
                                    </View>
                                :
                                    null
                            }
                            {sections.map(item => {

                                return <Category
                                    item={item}
                                />;
                            })}
                        </div>
                    </View>
                    :
                    null
            }
            {
                isPdf ?
                    <View className={'col-lg-4'}>
                        <View
                            className={'card'}
                            style={{marginBottom: 30}}
                        >
                            <View
                                className={'card-body'}
                                style={{padding: 0}}
                            >
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        padding: 15,
                                        borderBottom: '1px solid #dddddd'
                                    }}
                                >
                                    <h1
                                        style={{marginBottom: 0}}
                                    >
                                        {TMenuEditorScreen[AppConfig.lang].UPLOAD_FILE}
                                    </h1>
                                </View>
                                <div
                                    style={{padding: 15, paddingTop: 0}}
                                >
                                    {
                                        uploadingFile ?
                                            <ActivityIndicator/>
                                            :
                                            menu.totalPdfPages ?
                                                <View>
                                                    <CCText style={{fontSize: 20}}>
                                                        {TMenuEditorScreen[AppConfig.lang].FILE_UPLOADED}
                                                    </CCText>
                                                    <View
                                                        style={{
                                                            flexDirection: 'row',
                                                            justifyContent: 'flex-start',
                                                            marginTop: 10
                                                        }}
                                                    >
                                                        <BorderlessButton
                                                            text={TMenuEditorScreen[AppConfig.lang].DELETE}
                                                            style={{padding: '3px 10px'}}
                                                            textStyle={{...Styles.redColor}}
                                                            onPress={async () => {
                                                                setUploadingFile(true)

                                                                const response = await fetch(AppConfig.URL + "/Menu/RemovePdf/" + id, {
                                                                    method: 'GET',
                                                                    headers: {
                                                                        'Accept': 'application/json',
                                                                        'Content-Type': 'application/json',
                                                                        'Authorization': auth.token
                                                                    }
                                                                });

                                                                const r = await response.json();

                                                                if (r.success) {
                                                                    const updatedMenu = {...menu}

                                                                    updatedMenu.totalPdfPages = null

                                                                    setMenu(updatedMenu)
                                                                    setUploadingFile(false)
                                                                }
                                                            }}
                                                        />
                                                    </View>
                                                </View>
                                                :
                                                <View>
                                                    <input
                                                        ref={pdfInputRef}
                                                        type={'file'}
                                                        accept={'application/pdf'}
                                                        onChange={(event) => {
                                                            // @ts-ignore
                                                            const file = event.target.files[0];

                                                            if (file) {
                                                                if (file.type !== "application/pdf") {
                                                                    setPdfUploadMessage(TMenuEditorScreen[AppConfig.lang].MESSAGE_ONLY_PDF_FILES)
                                                                    return;
                                                                }

                                                                //if (file.size > 20971520) { // 20 MB
                                                                if (file.size > 52428800) { // 50 MB
                                                                    setPdfUploadMessage(TMenuEditorScreen[AppConfig.lang].MESSAGE_MAX_SIZE)
                                                                    return;
                                                                }

                                                                setUploadingFile(true)

                                                                const reader = new FileReader();
                                                                reader.onload = async (loadEvent) => {
                                                                    // @ts-ignore
                                                                    const base64String = loadEvent.target.result;

                                                                    const response = await fetch(AppConfig.URL + "/Menu/UploadPdf/" + id, {
                                                                        method: 'POST',
                                                                        headers: {
                                                                            'Accept': 'application/json',
                                                                            'Content-Type': 'application/json',
                                                                            'Authorization': auth.token
                                                                        },
                                                                        body: JSON.stringify({
                                                                            File: base64String,
                                                                        })
                                                                    });

                                                                    const r = await response.json();

                                                                    if (r.success) {
                                                                        const updatedMenu = {...menu}

                                                                        updatedMenu.totalPdfPages = 1

                                                                        setMenu(updatedMenu)
                                                                    }

                                                                    setUploadingFile(false)
                                                                };
                                                                reader.readAsDataURL(file);
                                                            }
                                                        }}
                                                    />
                                                    {
                                                        pdfUploadMessage ?
                                                            <View
                                                                className={'alert alert-danger'}
                                                                style={{marginTop: 15}}
                                                            >
                                                                {pdfUploadMessage}
                                                            </View>
                                                            :
                                                            null
                                                    }
                                                </View>
                                    }
                                </div>
                            </View>
                        </View>
                    </View>
                    :
                    null
            }
        </View>
        <View style={{height: 140}}></View>
        <FormModalTS
            title={TMenuEditorScreen[AppConfig.lang].NEW_SECTION}
            form={sectionForm}
            isOpen={isNewSectionModalOpen}
            toggle={() => setIsNewSectionModalOpen(!isNewSectionModalOpen)}
            confirmFunction={async () => {
                const controls = {...sectionForm.controls}

                if (sectionForm.isValidForm) {
                    let formData = {};

                    formData['MSE_MENU_ID'] = id;

                    for (let key in sectionForm.controls) {
                        formData[key] = sectionForm.controls[key].value;
                    }

                    const response = await fetch(AppConfig.URL + "/Menu/CreateSection", {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        },
                        body: JSON.stringify(formData)
                    });

                    var json = await response.json();

                    if (json.success) {
                        const section = json.section;
                        const updatedSections = [...sections];

                        section.food = [];

                        updatedSections.unshift(section);

                        for (let key in controls) {
                            controls[key].value = '';
                        }

                        setSections(updatedSections)
                        setSectionForm(new ChocoForm(controls))
                        setIsNewSectionModalOpen(false)
                    }
                } else {
                    setIsNewSectionModalOpen(false)
                }
            }}
            confirmText={TMenuEditorScreen[AppConfig.lang].SAVE}
            cancelText={TMenuEditorScreen[AppConfig.lang].CANCEL}
            onFormChange={(updatedForm) => {
                setSectionForm(updatedForm)
            }}
        />
    </View>;
}

export default MenuEditorScreen;


const Category = ({item}) => {
    const auth = GetAuthObject()

    const [section, setSection] = useState<MenuSection | null>(item)
    const [isEditSectionModalOpen, setIsEditSectionModalOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [alertData, setAlertData] = useState({
        visible: false,
        title: '',
        text: '',
        buttons: Array<any>()
    });
    const [form, setForm] = useState<ChocoForm>(new ChocoForm({
            mse_name: new ChocoControl({
                elementType: 'input',
                elementConfig: {
                    placeholder: TMenuEditorScreen[AppConfig.lang].SECTION_NAME,
                    autoCapitalize: 'words'
                },
                label: TMenuEditorScreen[AppConfig.lang].SECTION_NAME + '*',
                value: item.mse_name,
                errorMessage: '',
                validation: new ChocoValidation({
                    required: true,
                    maxLength: 50
                }),
            }),
            mse_description: new ChocoControl({
                elementType: 'input',
                elementConfig: {
                    placeholder: TMenuEditorScreen[AppConfig.lang].SECTION_DESC,
                    autoCapitalize: 'words'
                },
                label: TMenuEditorScreen[AppConfig.lang].SECTION_DESC,
                value: item.mse_description,
                errorMessage: '',
                validation: new ChocoValidation({
                    required: false,
                    maxLength: 500
                }),
            }),
    }));

    useEffect(() => {
        if(section)
            setSection(item)
    }, [item]);

    if(!section)
        return null

    const DeleteSection = () => {
        setAlertData({
            visible: !alertData.visible,
            title: TMenuEditorScreen[AppConfig.lang].DELETE_SECTION_TITLE,
            text: TMenuEditorScreen[AppConfig.lang].DELETE_SECTION_TEXT + ' (' + section.mse_name + ')',
            buttons: [
                {
                    text: TMenuEditorScreen[AppConfig.lang].CANCEL,
                    onPress: () => {
                    },
                    style: "cancel"
                },
                {
                    text: TMenuEditorScreen[AppConfig.lang].CONFIRM_DELETE_SECTION_TEXT,
                    onPress: async () => {
                        setDeleting(true)

                        const response = await fetch(AppConfig.URL + "/Menu/DeleteSection/" + section.mse_id, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': auth.token
                            }
                        });

                        var json = await response.json();

                        if (json.success) {
                            setSection(null)

                            setDeleting(false)
                        }
                    }
                }
            ]
        })
    }

    return <View
        className={'col-12 col-md-6 col-lg-4 col-xl-3'}
    >
        <TouchableWithoutFeedback
            key={section.mse_id}
            style={{
                marginTop: 15
            }}
            to={'/admin/menu/category/' + section.mse_id}
        >
            <View
                className={'card'}
                style={{
                    overflow: 'initial'
                }}
            >
                <View
                    className={'card-body'}
                >
                    <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                        <View>
                            <CCText
                                style={{
                                    fontWeight: 'bold'
                                }}
                            >
                                {section.mse_name}
                            </CCText>
                        </View>
                        {deleting ?
                            <ActivityIndicator/>
                            :
                            <DropdownMenu
                                buttonText={<GearIcon/>}
                                options={[
                                    {
                                        text: TMenuEditorScreen[AppConfig.lang].EDIT,
                                        onPress: () => {
                                            setIsEditSectionModalOpen(!isEditSectionModalOpen)
                                        }
                                    },
                                    {
                                        textStyle: Styles.redColor,
                                        text: TMenuEditorScreen[AppConfig.lang].DELETE_SECTION,
                                        onPress: () => {
                                            DeleteSection()
                                        }
                                    }
                                ]}
                            />
                        }
                    </View>
                    {
                        section.mse_description ?
                            <CCText
                                style={{
                                    color: 'gray',
                                    fontSize: '1.15rem'
                                }}
                            >
                                {section.mse_description}
                            </CCText>
                            :
                            null
                    }
                </View>
            </View>
        </TouchableWithoutFeedback>
        <AlertModal
            visible={alertData.visible}
            onRequestClose={() => {
                const alertDataCopy = {...alertData}

                alertDataCopy.visible = !alertDataCopy.visible

                setAlertData(alertDataCopy)
            }}
            title={alertData.title}
            text={alertData.text}
            buttons={alertData.buttons}
        />
        <FormModalTS
            title={TMenuEditorScreen[AppConfig.lang].EDIT}
            form={form}
            isOpen={isEditSectionModalOpen}
            toggle={() => setIsEditSectionModalOpen(!isEditSectionModalOpen)}
            confirmFunction={async () => {
                const controls = {...form.controls}

                if (form.isValidForm) {
                    let formData = {};

                    formData['mse_id'] = section.mse_id;

                    for (let key in controls) {
                        formData[key] = controls[key].value;
                    }

                    const response = await fetch(AppConfig.URL + "/Menu/CreateSection", {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        },
                        body: JSON.stringify(formData)
                    });

                    const json = await response.json();

                    if (json.success) {
                        const updatedSection = json.section;

                        setForm(new ChocoForm(controls))
                        setIsEditSectionModalOpen(false)
                        setSection(updatedSection)
                    }
                }
            }}
            confirmText={TMenuEditorScreen[AppConfig.lang].SAVE}
            cancelText={TMenuEditorScreen[AppConfig.lang].CANCEL}
            onFormChange={(updatedForm) => {
                setForm(updatedForm)
            }}
        />
    </View>;
}